export const GuideDoc = 
{
    mainTitle:"",
    mainText:"",
    paragraph:[
        {
            number:"1",
            pTitle:"前言",
            pText:"國家電影及視聽文化中心歷年來蒐集豐富的電影史料，為妥善保存影視聽史料，建置「藏品檢索系統」，提供各界查詢本中心典藏文物之目錄資訊，以達資源分享與利用目的。本系統提供目前已校對整理完成之目錄資訊約1萬筆，後續將因應藏品著作權利取得、蒐藏及編目進度逐步擴增。數位典藏時期(2007-2010)建置<a href='http://search.tfai.org.tw/TFDBSearch/index.php'>典藏檢索</a>網站待與本系統資料整合完成前仍繼續開放使用。<br/>本目錄系統以提供目錄資訊為主，包含電影膠片，電影衍生文物如海報類、器物類、影片數位檔案等。<span class='guideSpan'>數位化圖檔因須與著作權利所有人洽談授權，目前僅提供新聞片數位檔案與器物類作為瀏覽。</span>藏品能否租借，本中心需視藏品狀態、有無權限等因素而評估，若需取用請填寫<a href='https://www.tfai.org.tw/downloads/rent'>資料借出使用申請單</a>，向本中心提出申請。",
            subParagraph:[
            ]
        },
        {
            number:"2",
            pTitle:"藏品單元簡介",
            pText:"各類藏品之目錄著錄原則，以文物上的原始資訊為主，將以 [ ] 標示修正後資訊或別名。",
            subParagraph:[
                {
                    number:"2.1",
                    spTitle:"膠片類",
                    spText:"膠片類一部電影作品，若有聲片、底片、字片、拷貝片、預告片等5套膠片，則系統內顯示5筆資料。聲片、底片因實體物件上並無導演、演職員表相關資料，該筆資訊並未呈現上述資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[
                    ]

                },
                {
                    number:"2.2",
                    spTitle:"新聞片",
                    spText:"一則新聞影片為1筆資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[
                    ]

                },
                {
                    number:"2.3",
                    spTitle:"海報類文物",
                    spText:"一部電影作品若有3種不同版本的海報，則系統內顯示3筆資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[
                    ]

                },
                {
                    number:"2.4",
                    spTitle:"器物類文物",
                    spText:"一部器物為1筆資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[
                    ]

                },
                {
                    number:"2.5",
                    spTitle:"數位修復影片",
                    spText:"一部數位修復電影作品顯示1筆資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[
                    ]

                },
            ]

        },
        {
            number:"3",
            pTitle:"目錄查詢方式",
            pText:"以下簡述如何進行資料瀏覽及檢索",
            subParagraph:[
                {
                    number:"3.1",
                    spTitle:"目錄瀏覽",
                    spUrl:"",
                    thirdLevelParagraph:[
                        {
                            type:'image',
                            image:'home1-edit'
                        },
                        {
                            type:'image',
                            image:'home2-edit'
                        },
                        {
                            type:'text',
                            text:"目錄瀏覽方式，適用於當您尚無明確目標，或者不確定要用什麼字詞檢索時使用。「目錄瀏覽」是以直接點選方式提供膠片、數位修復影片、新聞片數位檔案、海報與器物各類別，可依據類別進行藏品瀏覽。目錄搜尋則以關鍵詞進行藏品搜尋。本系統可使用布林邏輯語法進行檢索。"
                        },
                        {
                            type:'image',
                            image:'list1-edit'
                        },
                        {
                            type:'image',
                            image:'list2-edit'
                        }
                    ],
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"3.2",
                    spTitle:"布林邏輯",
                    spText:"布林邏輯是線上檢索中最常用的技巧，包括AND、OR、NOT三個基本運算元，可以單獨或配合使用。其中AND表示交集，可設定文件中須同時含有檢索詞彙；OR表示聯集，文件中只要含有其中之一的檢索詞彙即會被檢索出；NOT則是可將含有不需要的詞彙的文件排除。目前大部分的搜尋引擎多提供了布林邏輯檢索的功能，使用者可以藉其組合檢索詞彙做更有效的查詢。<br/>範例一：以「環保」 AND 「資源回收」查詢，可查到同時含有「環保」和「資源回收」的資料。<br/>範例二：以 「二二八事件」 OR 「白色恐怖」查詢可查到關於含有「二二八事件」或含有「白色恐怖」的資料。<br/>範例三：以「墨西哥」 NOT 「新墨西哥」查詢則可查到關於「墨西哥」的資料並排除含有「新墨西哥」的資料。<br/>範例四：若想查詢演員徐楓或石雋，分別跟胡金銓導演合作的作品，可將進階查詢條件設為徐楓AND胡金銓OR石雋AND胡金銓，則能查到「徐楓與胡金銓合作的作品」或「石雋與胡金銓合作的作品」。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                }
            ]
        },
        {
            number:"4",
            pTitle:"目錄查詢結果顯示",
            pText:"以下章節將說明，當您下關鍵字進行搜尋後，搜尋結果的頁面呈現。下圖範例是全部種類藏品查詢之結果列表頁，各種類之藏品亦有各自之結果列表頁，僅會顯示該類別藏品之查詢結果。",
            image:"list3-edit",
            subParagraph:[
                {
                    number:"4.1",
                    spTitle:'搜尋結果列',
                    spText:'搜尋結果頁面中間為搜尋結果列表，上圖4.1處，即為其中一筆搜尋結果。在列表中，僅有該筆資料的[藏品名稱]、[藏品類]、[年份]、[藏品編號]此4欄的資訊呈現，如果您想要知道更詳細的資訊，請點擊該筆資料，進入詳細資料頁面瀏覽。',
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.2",
                    spTitle:"關鍵字輸入框",
                    spText:"此處輸入您想要查詢的關鍵字。當您輸入第一個字後，系統會自動列出候選字詞，邏輯是以查詢頻率最高5名作為候選字詞。查詢至多可以同時5個關鍵字，各關鍵字間以空格間隔，表示前述3.2節提及的布林邏輯中的AND。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.3",
                    spTitle:"進階查詢關鍵字輸入框",
                    spText:"點擊進階查詢後，會顯示該輸入框，點擊一般查詢可關閉輸入框。可以透過＋、－按鈕新增或刪減輸入框數量，包含4.2輸入框至多五個。每欄代表一個關鍵詞，每個關鍵詞前，可以透過下拉選單選取前述3.2節提及的布林邏輯(AND、OR、NOT)關連。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.4",
                    spTitle:"藏品類型",
                    spText:"可察看目前瀏覽的藏品類型，也可以透過點選增加或減少瀏覽的藏品類型。藏品類型有:膠片類、海報類、器物類、新聞片、數位修復影片。該欄空白時，則顯示全部藏品類型的資料。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.5",
                    spTitle:"藏品出品年代",
                    spText:"目前顯示之藏品的年份介於的西元年代區間，可以透過點選修改欲查詢的年代區間。輸入起年表示該年的1月1日起；輸入迄年表示該年的12月31日止，例如：輸入1957~2023，表示日期於1957-01-01至2023-12-31間的藏品。年代起迄皆為空白時，將顯示所有年代的藏品，包含沒有年份的藏品。當輸入起或迄年其中之一，未有年份之藏品將不會顯示。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.6",
                    spTitle:"搜尋結果排序功能區",
                    spText:"搜尋結果列出後，您可以再把搜尋結果依您所選擇的欄位進行升降排序。可排序的欄位有：[藏品種類]、[標題]、[年份]、[原始藏品編號]。上述的欄位中，並非每個種類皆有[年份]，無此欄位之種類，於排序時，視為空值進行排序。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.7",
                    spTitle:"搜尋關鍵字及結果筆數",
                    spText:"此區域顯示此次搜尋所下之關鍵字，所有關鍵字會以反黃呈現。下方列則會顯示符合本次搜尋條件之資料筆數。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.8",
                    spTitle:"跳頁功能列",
                    spText:"此區域會顯示列表頁之資料之總頁數，以及目前所在之頁數。使用者可於此處選擇每頁之呈現資料筆數，如果搜尋結果頁數較多的時候，可以選擇跳前一頁、跳後一頁、跳前十頁、跳後十頁、跳最前頁、跳最後頁、或是直接輸入頁碼直接跳轉。",
                    spUrl:"",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                },
                {
                    number:"4.9",
                    spTitle:"資料詳目頁",
                    spText:"當您從結果列表頁點擊任一筆資料後，頁面即跳轉到該筆資料之詳目頁。於此頁面中，會呈現目前中心藏品資料庫中，該筆藏品符合對外界發布之所有欄位資料。如果是新聞片資料，即可於此頁面撥放該新聞片數位化之影片 (解析度720x480)。其他類藏品未來經取得授權會持續放上相關圖檔或影音檔資料。",
                    spUrl:"",
                    image:"detail-edit",
                    inputTableText:null,
                    inputTable:[
                    ],
                    outputTableText:"",
                    outputTable:[                     
                    ]
                }
            ]
        }
    ]
}